import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";

export const LandingFactoidLikeFeature = ({
  isDark,
  title,
  description,
}: {
  isDark?: boolean;
  title: string;
  description: string;
}) => {
  const theme = useTheme();
  return (
    <Box
      component={Stack}
      spacing={1.5}
      sx={{
        p: 3,
        backgroundColor: isDark ? theme.palette.grey[900] : alpha(theme.palette.info.main, 0.08),
        borderRadius: 1.5,
        height: "100%",
      }}
    >
      <Typography variant="h5">{title}</Typography>
      <Typography variant={"body1"}>{description}</Typography>
    </Box>
  );
};
